package com.patronat.top.core.domain.models

import com.patronat.top.core.network.NetworkResult
import com.patronat.top.error.AppErrorCode

sealed interface DomainResult<out T> {
    data class Success<T>(val data: T) : DomainResult<T>
    data class Error(
        val type: AppErrorCode,
        val message: String? = null,
        val throwable: Throwable? = null) : DomainResult<Nothing>
}
